import { useEffect, useRef, useState } from "react";

export function PinBoxes({ onComplete, testid, resetKey }) {
  const refs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [digits, setDigits] = useState(["", "", "", ""]);

  useEffect(() => { setDigits(["", "", "", ""]); }, [resetKey]);

  const change = (i, v) => {
    const d = v.replace(/\D/g, "").slice(-1);
    const next = [...digits];
    next[i] = d;
    setDigits(next);
    if (d && i < 3) refs[i + 1].current?.focus();
    if (next.every((x) => x !== "")) onComplete(next.join(""));
  };
  const keyDown = (i, e) => {
    if (e.key === "Backspace" && !digits[i] && i > 0) refs[i - 1].current?.focus();
  };

  return (
    <div className="flex justify-center gap-3" key={resetKey}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={refs[i]}
          data-testid={`${testid}-digit-${i}`}
          type="password"
          inputMode="numeric"
          maxLength={1}
          value={d}
          autoFocus={i === 0}
          onChange={(e) => change(i, e.target.value)}
          onKeyDown={(e) => keyDown(i, e)}
          className="w-14 h-16 text-center text-2xl font-display text-amber-100 bg-[#1a0b2b] border border-[#4a2175] rounded-xl focus:outline-none focus:border-amber-400/70 focus:shadow-[0_0_18px_rgba(251,191,36,0.15)] transition-all"
        />
      ))}
    </div>
  );
}
